import React from 'react';
import type { HealthBreakdown } from '../types';

const ROWS: Array<[string, keyof HealthBreakdown, number]> = [
  ['写真',         'photos',                15],
  ['口コミ件数',   'reviews_count',         15],
  ['口コミ量級',   'review_volume_tier',    15],
  ['平均評価',     'rating',                10],
  ['カテゴリ',     'categories',            10],
  ['説明文',       'description',           10],
  ['完全性',       'presence_completeness', 10],
  ['ウェブサイト', 'website',                5],
  ['電話番号',     'phone',                  5],
  ['主要タイプ',   'primary_type_set',       5],
];

const BreakdownChart: React.FC<{ breakdown: HealthBreakdown }> = ({ breakdown }) => (
  <div className="py-4 border-b border-slate-200">
    <div className="flex items-baseline justify-between mb-3 flex-wrap gap-2">
      <h3 className="text-[13px] font-semibold text-slate-900">MEO健全度スコア 内訳</h3>
      <span className="text-[11px] text-slate-500">低い項目が改善優先候補</span>
    </div>
    <div className="space-y-2">
      {ROWS.map(([label, key, max]) => {
        const value = breakdown[key];
        const pct = Math.round((value / max) * 100);
        return (
          <div key={key} className="flex items-center gap-3">
            <span className="text-[12px] text-slate-700 w-28 shrink-0">{label}</span>
            <div className="flex-1 bg-slate-100 h-1.5 overflow-hidden">
              <div className="h-full bg-leaf-500 transition-all" style={{ width: `${pct}%` }} />
            </div>
            <span className="text-[11px] tabular-nums text-slate-600 w-16 text-right">{value} / {max}</span>
          </div>
        );
      })}
    </div>
  </div>
);

export default BreakdownChart;
